import Model from "../../Model.js";

/**
 * `KeyFigureValue` encapsulate the value of a keyFigure for a given
 * period.
 *
 * @param {Period} period - Period for which the value was computed
 * @param {number} value - The computed value
 * @param {KeyFigure} component - The key figure for which the value
 *   was computed
 */
export default class KeyFigureValue extends Model {
	constructor({ period, value, component }) {
		super(...arguments);

		this._period = period;
		this._value = value;
		this._keyFigure = component;
	}

	getPeriod() {
		return this._period;
	}

	getValue() {
		return this._value;
	}

	getComponent() {
		return this._keyFigure;
	}

	getComponentId() {
		return this._keyFigure.getId();
	}

	getNumberOfDecimals() {
		return this._keyFigure.getNumberOfDecimals();
	}

	getName() {
		return this._keyFigure.getName();
	}

	getValueType() {
		return this._keyFigure.getValueType();
	}

	isKeyFigureValue() {
		return false;
	}

	isPercentage() {
		return this._keyFigure.isPercentage();
	}

	isForActivePeriod() {
		return this._period.isActive();
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.period = context.findPeriodById(data.periodId);
		data.component = context.keyFigures[data.keyFigureId];
	}

	static getType() {
		return "KeyFigure";
	}
}
